export const CommunityStats = {
  // Aggregated community stats
  GET_COMMUNITY_AGGREGATED_STATS: "GET_COMMUNITY_AGGREGATED_STATS",
  GET_COMMUNITY_AGGREGATED_STATS_SUCCESS: "GET_COMMUNITY_AGGREGATED_STATS_SUCCESS",
  
  // Community Notices
  GET_NEIGHBORS_NOTICES: "GET_NEIGHBORS_NOTICES",
  GET_NEIGHBORS_NOTICES_SUCCESS: "GET_NEIGHBORS_NOTICES_SUCCESS",
  
  // Community Calendar
  GET_NEIGHBORS_CALENDAR: "GET_NEIGHBORS_CALENDAR",
  GET_NEIGHBORS_CALENDAR_SUCCESS: "GET_NEIGHBORS_CALENDAR_SUCCESS",
  
  // Community Polls
  GET_NEIGHBORS_POLLS: "GET_NEIGHBORS_POLLS",
  GET_NEIGHBORS_POLLS_SUCCESS: "GET_NEIGHBORS_POLLS_SUCCESS",
  
  // Community Payments/Fundraisers
  GET_NEIGHBORS_PAYMENTS: "GET_NEIGHBORS_PAYMENTS",
  GET_NEIGHBORS_PAYMENTS_SUCCESS: "GET_NEIGHBORS_PAYMENTS_SUCCESS",
  
  // Community Files
  GET_NEIGHBOURS_FILES: "GET_NEIGHBOURS_FILES",
  GET_NEIGHBOURS_FILES_SUCCESS: "GET_NEIGHBOURS_FILES_SUCCESS",
  
  // Community Services
  GET_NEIGHBORS_SERVICES: "GET_NEIGHBORS_SERVICES",
  GET_NEIGHBORS_SERVICES_SUCCESS: "GET_NEIGHBORS_SERVICES_SUCCESS",
  
  // Community Meetings
  GET_NEIGHBORS_MEETINGS: "GET_NEIGHBORS_MEETINGS",
  GET_NEIGHBORS_MEETINGS_SUCCESS: "GET_NEIGHBORS_MEETINGS_SUCCESS",
  GET_NEIGHBORS_MEETINGS_ERROR: "GET_NEIGHBORS_MEETINGS_ERROR",
  
  // Community Wallets
  GET_NEIGHBORS_WALLETS: "GET_NEIGHBORS_WALLETS",
  GET_NEIGHBORS_WALLETS_SUCCESS: "GET_NEIGHBORS_WALLETS_SUCCESS",
  
  // Community Utility Bills
  GET_COMMUNITY_UTILITY_BILLS: "GET_COMMUNITY_UTILITY_BILLS",
  GET_COMMUNITY_UTILITY_BILLS_SUCCESS: "GET_COMMUNITY_UTILITY_BILLS_SUCCESS",
  
  // Add missing action constants
  GET_COMMUNITY_CHATS: "GET_COMMUNITY_CHATS",
  GET_COMMUNITY_CHATS_SUCCESS: "GET_COMMUNITY_CHATS_SUCCESS",
  
  GET_COMMUNITY_TRANSACTIONS: "GET_COMMUNITY_TRANSACTIONS",
  GET_COMMUNITY_TRANSACTIONS_SUCCESS: "GET_COMMUNITY_TRANSACTIONS_SUCCESS",
  GET_COMMUNITY_TRANSACTIONS_ERROR: "GET_COMMUNITY_TRANSACTIONS_ERROR",
  
  GET_COMMUNITY_BANK_ACCOUNTS: "GET_COMMUNITY_BANK_ACCOUNTS",
  GET_COMMUNITY_BANK_ACCOUNTS_SUCCESS: "GET_COMMUNITY_BANK_ACCOUNTS_SUCCESS",
  
  GET_COMMUNITY_FOLDERS: "GET_COMMUNITY_FOLDERS",
  GET_COMMUNITY_FOLDERS_SUCCESS: "GET_COMMUNITY_FOLDERS_SUCCESS",
  
  GET_COMMUNITY_MEMBERS: "GET_COMMUNITY_MEMBERS",
  GET_COMMUNITY_MEMBERS_SUCCESS: "GET_COMMUNITY_MEMBERS_SUCCESS",
  
  GET_COMMUNITY_ADMINISTRATORS: "GET_COMMUNITY_ADMINISTRATORS",
  GET_COMMUNITY_ADMINISTRATORS_SUCCESS: "GET_COMMUNITY_ADMINISTRATORS_SUCCESS",
  
  GET_COMMUNITY_PRINT_ORDERS: "GET_COMMUNITY_PRINT_ORDERS",
  GET_COMMUNITY_PRINT_ORDERS_SUCCESS: "GET_COMMUNITY_PRINT_ORDERS_SUCCESS",
  
  // Add missing polls actions
  GET_COMMUNITY_POLLS: "GET_COMMUNITY_POLLS",
  GET_COMMUNITY_POLLS_SUCCESS: "GET_COMMUNITY_POLLS_SUCCESS",
  
  // Add missing funds actions
  GET_COMMUNITY_FUNDS: "GET_COMMUNITY_FUNDS", 
  GET_COMMUNITY_FUNDS_SUCCESS: "GET_COMMUNITY_FUNDS_SUCCESS",
};

// Action creators
export const getCommunityAggregatedStats = (payload) => ({
  type: CommunityStats.GET_COMMUNITY_AGGREGATED_STATS,
  payload,
});

export const getNeighborsNotices = (payload) => ({
  type: CommunityStats.GET_NEIGHBORS_NOTICES,
  payload,
});

export const getNeighborsCalendar = (payload) => ({
  type: CommunityStats.GET_NEIGHBORS_CALENDAR,
  payload,
});

export const getNeighborsPolls = (payload) => ({
  type: CommunityStats.GET_NEIGHBORS_POLLS,
  payload,
});

export const getNeighborsPayments = (payload) => ({
  type: CommunityStats.GET_NEIGHBORS_PAYMENTS,
  payload,
});

export const getNeighboursFiles = (payload) => ({
  type: CommunityStats.GET_NEIGHBOURS_FILES,
  payload,
});

export const getNeighboursServices = (payload) => ({
  type: CommunityStats.GET_NEIGHBORS_SERVICES,
  payload,
});

export const getNeighboursMeetings = (payload) => ({
  type: CommunityStats.GET_NEIGHBORS_MEETINGS,
  payload,
});

export const getNeighboursWallets = (payload) => ({
  type: CommunityStats.GET_NEIGHBORS_WALLETS,
  payload,
});

export const getCommunityUtilityBills = (payload) => ({
  type: CommunityStats.GET_COMMUNITY_UTILITY_BILLS,
  payload,
});

// Add missing action creators
export const getCommunityChats = (payload) => ({
  type: CommunityStats.GET_COMMUNITY_CHATS,
  payload,
});

export const getCommunityTransactions = (payload) => ({
  type: CommunityStats.GET_COMMUNITY_TRANSACTIONS,
  payload,
});

export const getCommunityBankAccounts = (payload) => ({
  type: CommunityStats.GET_COMMUNITY_BANK_ACCOUNTS,
  payload,
});

export const getCommunityFolders = (payload) => ({
  type: CommunityStats.GET_COMMUNITY_FOLDERS,
  payload,
});

export const getCommunityMembers = (payload) => ({
  type: CommunityStats.GET_COMMUNITY_MEMBERS,
  payload,
});

export const getCommunityAdministrators = (payload) => ({
  type: CommunityStats.GET_COMMUNITY_ADMINISTRATORS,
  payload,
});

export const getCommunityPrintOrders = (payload) => ({
  type: CommunityStats.GET_COMMUNITY_PRINT_ORDERS,
  payload,
});

export const getCommunityPolls = (payload) => ({
  type: CommunityStats.GET_COMMUNITY_POLLS,
  payload,
});

export const getCommunityFunds = (payload) => ({
  type: CommunityStats.GET_COMMUNITY_FUNDS,
  payload,
});